import { Button, Typography, Grid } from '@material-ui/core';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      backgroundColor: theme.palette.background.default,
      borderRadius: 4,
      padding: theme.spacing(3),
      border: `1px solid ${theme.palette.primary.light}`,
      minHeight: '150px',
      alignItems: 'center',
    },
    item: {
      minHeight: '100px',
    },
    center: {
      display: 'flex',
      justifyContent: 'center',
    },
  }),
);

/**
 * Prerequisite card for onboarding an AI application to Azure.
 * Opens the AI onboarding scaffolder template in a new tab.
 */
export const OnboardAIApplication = () => {
  const classes = useStyles();

  const navigateToAIOnboarding = () => {
    window.open('/create/templates/default/gaas-ai-app-onboard', '_blank', 'noopener,noreferrer');
  };

  return (
    <div className={classes.container}>
      <Grid
        data-testid="onboard-ai-application"
        container
        spacing={2}
        direction="row"
        justifyContent="space-around"
        alignItems="center"
        className={classes.item}
      >
        <Grid md={10} item>
          <Typography variant="h6" aria-label="title">
            Onboard AI Application to Azure
          </Typography>
          <Typography variant="subtitle2" aria-label="description">
            Register and onboard your application for AI resources in Azure before creating an AI Agent.
          </Typography>
        </Grid>
        <Grid md={2} item className={classes.center}>
          <Button
            variant="contained"
            onClick={navigateToAIOnboarding}
            aria-label="btn-open-form"
            style={{ padding: '5px 11px' }}
          >
            ONBOARD
          </Button>
        </Grid>
      </Grid>
    </div>
  );
};
